module.exports = __webpack_public_path__ + "img/very-high.23425ae.svg";